<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'FINANCICAL_INSTITUTIONS', url: '/admin/financial-institutions' },
    { label: 'UPDATE_FINANCIAL_INSTITUTION' }
  ]"
></breadcrumbs>

<page-header title="UPDATE_FINANCIAL_INSTITUTION"></page-header>

<card>
  <form autocomplete="off" class="form" (submit)="onSubmit($event)">
    <div class="field is-narrow">
      <label class="label" translationEditableDirective="NAME">{{
        'NAME' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="name"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['name'])"
          [ngClass]="{ 'is-danger': hasError('name') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('name')">
        {{ getError('name') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="DESCRIPTION">{{
        'DESCRIPTION' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="description"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['description'])"
          [ngClass]="{ 'is-danger': hasError('description') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('description')">
        {{ getError('description') }}
      </p>
    </div>
  </form>
</card>

<div class="field is-grouped px-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      translationEditableDirective="SUBMIT"
      (click)="onSubmit($event)"
    >
      {{ 'SUBMIT' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/admin/financial-institutions']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
      >{{ 'CANCEL' | translate }}</a
    >
  </div>
</div>
